import React from 'react';
import { Typography, Box } from '@mui/material';
import { EmployeeAvatar } from '../../common/EmployeeAvatar';
import FeedbackCard from './FeedbackCard';
import { COLORS } from '../../../constants/radar';

const FeedbackOnDemandSection = ({ feedbackOnDemand }) => {
  if (!feedbackOnDemand) return null;

  return (
    <Box sx={{ mb: 4, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <EmployeeAvatar employee={feedbackOnDemand.sender} size={40} sx={{ mr: 2 }} />
        <Box>
          <Typography variant="h6" color={COLORS.PRIMARY}>
            {feedbackOnDemand.sender?.fullName || 'Unknown Sender'}
          </Typography>
          <Typography sx={{ 
            fontSize: '14px', 
            color: '#64748B',
            lineHeight: 1.3,
          }}>
            Feedback Actions
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' },
        gap: 2,
        flexWrap: 'wrap'
      }}>
        <FeedbackCard 
          type="Start" 
          content={feedbackOnDemand.startComments} 
          color={COLORS.PRIMARY} 
        />
        
        <FeedbackCard 
          type="Stop" 
          content={feedbackOnDemand.stopComments} 
          color={COLORS.WARNING} 
        />
        
        <FeedbackCard 
          type="Continue" 
          content={feedbackOnDemand.continueComments} 
          color={COLORS.SUCCESS} 
        />
        
        {!feedbackOnDemand.startComments && 
         !feedbackOnDemand.stopComments && 
         !feedbackOnDemand.continueComments && (
          <Typography variant="body2" color="text.secondary">
            No specific feedback actions provided.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default FeedbackOnDemandSection; 